module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "fmtitle"
  }, [_c('span', [_c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_v",
      "title": "v"
    }
  }, [_vm._v("Contents")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc",
    attrs: {
      "id": "int-1"
    }
  }, [_c('span', [_c('a', {
    attrs: {
      "href": "#/xhtml/Introduction#int1"
    }
  }, [_vm._v("Introduction: Knowledge Is Power")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1",
    attrs: {
      "id": "pt-1"
    }
  }, [_c('span', [_c('a', {
    attrs: {
      "href": "#/xhtml/Part01#pt1"
    }
  }, [_vm._v("PART I: PESTICIDES ARE POISONS")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc",
    attrs: {
      "id": "ch-1"
    }
  }, [_c('span', [_c('a', {
    attrs: {
      "href": "#/xhtml/Chapter01#ch1"
    }
  }, [_vm._v("1.")]), _c('span', {
    staticClass: "cspace"
  }, [_c('span', {
    staticClass: "hide"
  }), _c('a', {
    attrs: {
      "href": "#/xhtml/Chapter01#ch1"
    }
  }, [_vm._v("The Ruffec Appeal and the Battle of Paul François")])])])]), _vm._v(" "), _c('p', {
    staticClass: "toc",
    attrs: {
      "id": "ch-2"
    }
  }, [_c('span', [_c('a', {
    attrs: {
      "href": "#/xhtml/Chapter02#ch2"
    }
  }, [_vm._v("2.")]), _c('span', {
    staticClass: "cspace"
  }, [_c('span', {
    staticClass: "hide"
  }), _c('a', {
    attrs: {
      "href": "#/xhtml/Chapter02#ch2"
    }
  }, [_vm._v("Chemical Weapons Recycled for Agriculture")])])])]), _vm._v(" "), _c('p', {
    staticClass: "toc",
    attrs: {
      "id": "ch-3"
    }
  }, [_c('span', [_c('a', {
    attrs: {
      "href": "#/xhtml/Chapter03#ch3"
    }
  }, [_vm._v("3.")]), _c('span', {
    staticClass: "cspace"
  }, [_c('span', {
    staticClass: "hide"
  }), _c('a', {
    attrs: {
      "href": "#/xhtml/Chapter03#ch3"
    }
  }, [_vm._v("“Elixirs of Death”")])])])]), _vm._v(" "), _c('p', {
    staticClass: "toc",
    attrs: {
      "id": "ch-4"
    }
  }, [_c('span', [_c('a', {
    attrs: {
      "href": "#/xhtml/Chapter04#ch4"
    }
  }, [_vm._v("4.")]), _c('span', {
    staticClass: "cspace"
  }, [_c('span', {
    staticClass: "hide"
  }), _c('a', {
    attrs: {
      "href": "#/xhtml/Chapter04#ch4"
    }
  }, [_vm._v("Ill from Pesticides")])])])]), _vm._v(" "), _c('p', {
    staticClass: "toc",
    attrs: {
      "id": "ch-5"
    }
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/xhtml/Chapter05#ch5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("5.")]), _c('span', {
    staticClass: "cspace"
  }, [_c('span', {
    staticClass: "hide"
  }), _c('span', {
    attrs: {
      "href": "#/xhtml/Chapter05#ch5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Pesticides and Cancer: Consistent Studies")])])])]), _vm._v(" "), _c('p', {
    staticClass: "toc",
    attrs: {
      "id": "ch-6"
    }
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/xhtml/Chapter06#ch6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("6.")]), _c('span', {
    staticClass: "cspace"
  }, [_c('span', {
    staticClass: "hide"
  }), _c('span', {
    attrs: {
      "href": "#/xhtml/Chapter06#ch6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Unstoppable Rise of Pesticides and Neurodegenerative Diseases")])])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1",
    attrs: {
      "id": "pt-2"
    }
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/xhtml/Part02#pt2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("PART II: SCIENCE AND INDUSTRY: MANUFACTURING DOUBT")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc",
    attrs: {
      "id": "ch-7"
    }
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/xhtml/Chapter07#ch7",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("7.")]), _c('span', {
    staticClass: "cspace"
  }, [_c('span', {
    staticClass: "hide"
  }), _c('span', {
    attrs: {
      "href": "#/xhtml/Chapter07#ch7",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Sinister Side of Progress")])])])]), _vm._v(" "), _c('p', {
    staticClass: "toc",
    attrs: {
      "id": "ch-8"
    }
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/xhtml/Chapter08#ch8",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("8.")]), _c('span', {
    staticClass: "cspace"
  }, [_c('span', {
    staticClass: "hide"
  }), _c('span', {
    attrs: {
      "href": "#/xhtml/Chapter08#ch8",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Industry Lays Down the Law")])])])]), _vm._v(" "), _c('p', {
    staticClass: "toc",
    attrs: {
      "id": "ch-9"
    }
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/xhtml/Chapter09#ch9",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("9.")]), _c('span', {
    staticClass: "cspace"
  }, [_c('span', {
    staticClass: "hide"
  }), _c('span', {
    attrs: {
      "href": "#/xhtml/Chapter09#ch9",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Mercenaries of Science")])])])]), _vm._v(" "), _c('p', {
    staticClass: "toc",
    attrs: {
      "id": "ch-10"
    }
  }, [_c('span', [_c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_vi",
      "title": "vi"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/Chapter10#ch10",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("10.")]), _c('span', {
    staticClass: "cspace"
  }, [_c('span', {
    staticClass: "hide"
  }), _c('span', {
    attrs: {
      "href": "#/xhtml/Chapter10#ch10",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Institutional Lies")])])])])]), _vm._v(" "), _c('p', {
    staticClass: "toc",
    attrs: {
      "id": "ch-11"
    }
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/xhtml/Chapter11#ch11",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("11.")]), _c('span', {
    staticClass: "cspace"
  }, [_c('span', {
    staticClass: "hide"
  }), _c('span', {
    attrs: {
      "href": "#/xhtml/Chapter11#ch11",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("An Epidemic of Chronic Diseases")])])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1",
    attrs: {
      "id": "pt-3"
    }
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/xhtml/Part03#pt3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("PART III: REGULATION AT INDUSTRY’S BECK AND CALL")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc",
    attrs: {
      "id": "ch-12"
    }
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/xhtml/Chapter12#ch12",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("12.")]), _c('span', {
    staticClass: "cspace"
  }, [_c('span', {
    staticClass: "hide"
  }), _c('span', {
    attrs: {
      "href": "#/xhtml/Chapter12#ch12",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Colossal Scientific Masquerade Behind Poisons’ “Acceptable Daily Intakes”")])])])]), _vm._v(" "), _c('p', {
    staticClass: "toc",
    attrs: {
      "id": "ch-13"
    }
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/xhtml/Chapter13#ch13",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("13.")]), _c('span', {
    staticClass: "cspace"
  }, [_c('span', {
    staticClass: "hide"
  }), _c('span', {
    attrs: {
      "href": "#/xhtml/Chapter13#ch13",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Unsolvable Conundrum of “Maximum Residue Limits”")])])])]), _vm._v(" "), _c('p', {
    staticClass: "toc",
    attrs: {
      "id": "ch-14"
    }
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/xhtml/Chapter14#ch14",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("14.")]), _c('span', {
    staticClass: "cspace"
  }, [_c('span', {
    staticClass: "hide"
  }), _c('span', {
    attrs: {
      "href": "#/xhtml/Chapter14#ch14",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Aspartame and Regulation: How Industry Is Pulling the Strings")])])])]), _vm._v(" "), _c('p', {
    staticClass: "toc",
    attrs: {
      "id": "ch-15"
    }
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/xhtml/Chapter15#ch15",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("15.")]), _c('span', {
    staticClass: "cspace"
  }, [_c('span', {
    staticClass: "hide"
  }), _c('span', {
    attrs: {
      "href": "#/xhtml/Chapter15#ch15",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Dangers of Aspartame and the Silence of Public Authorities")])])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1",
    attrs: {
      "id": "pt-4"
    }
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/xhtml/Part04#pt4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("PART IV: THE SHOCKING SCANDAL OF ENDOCRINE DISRUPTORS")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc",
    attrs: {
      "id": "ch-16"
    }
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/xhtml/Chapter16#ch16",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("16.")]), _c('span', {
    staticClass: "cspace"
  }, [_c('span', {
    staticClass: "hide"
  }), _c('span', {
    attrs: {
      "href": "#/xhtml/Chapter16#ch16",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("“Men in Peril”: Is the Human Species in Danger?")])])])]), _vm._v(" "), _c('p', {
    staticClass: "toc",
    attrs: {
      "id": "ch-17"
    }
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/xhtml/Chapter17#ch17",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("17.")]), _c('span', {
    staticClass: "cspace"
  }, [_c('span', {
    staticClass: "hide"
  }), _c('span', {
    attrs: {
      "href": "#/xhtml/Chapter17#ch17",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Distilbene: The “Perfect Model”?")])])])]), _vm._v(" "), _c('p', {
    staticClass: "toc",
    attrs: {
      "id": "ch-18"
    }
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/xhtml/Chapter18#ch18",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("18.")]), _c('span', {
    staticClass: "cspace"
  }, [_c('span', {
    staticClass: "hide"
  }), _c('span', {
    attrs: {
      "href": "#/xhtml/Chapter18#ch18",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Case of Bisphenol A: A Pandora’s Box")])])])]), _vm._v(" "), _c('p', {
    staticClass: "toc",
    attrs: {
      "id": "ch-19"
    }
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/xhtml/Chapter19#ch19",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("19.")]), _c('span', {
    staticClass: "cspace"
  }, [_c('span', {
    staticClass: "hide"
  }), _c('span', {
    attrs: {
      "href": "#/xhtml/Chapter19#ch19",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Cocktail Effect")])])])]), _vm._v(" "), _c('p', {
    staticClass: "toc",
    attrs: {
      "id": "bm-1"
    }
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/xhtml/Conclusion#bm1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Conclusion: A Paradigm Shift")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc",
    attrs: {
      "id": "bm-2"
    }
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/xhtml/Notes#bm2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Notes")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc",
    attrs: {
      "id": "bm-3"
    }
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/xhtml/Index#bm3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Index")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0df69bd0","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/Contents.vue
// module id = 69
// module chunks = 0